// SPDX-FileCopyrightText: © 2024 Schneider Electric
//
// SPDX-License-Identifier: Apache-2.0

import type { ComponentInterface } from '@stencil/core'
import { Component, Element, h } from '@stencil/core'

import type { Attributes } from '../../helpers'
import { inheritAriaAttributes } from '../../helpers'

/**
 * The `<qds-table>` element represents tabular data — that is, information
 * presented in a two-dimensional table comprised of rows and columns of cells
 * containing data.
 *
 * @see https://quartz.se.com/build/components/table
 */
@Component({
  tag: 'qds-table',
  shadow: true,
  styleUrl: 'table.css',
})
export class Table implements ComponentInterface {
  @Element() private readonly host!: HTMLElement

  #inheritedAttributes: Attributes = {}

  public componentWillLoad(): void {
    this.#inheritedAttributes = inheritAriaAttributes(this.host)
  }

  public render() {
    return (
      <table
        class="qds-table"
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...this.#inheritedAttributes}
      >
        <slot />
      </table>
    )
  }
}
